// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1wgxY","right":"Footer_right__2y8lF","buttons":"Footer_buttons__1XgSZ"};